import { z } from 'zod'
import { PublicShow } from './show-results-release.js'
import { PublicSeriesRef } from './series-publication.js'

const Count = z.number().int().nonnegative()
const ClassRef = z.strictObject({ modelClassKey: z.string(), name: z.string() })
const Odds = z.strictObject({
  entries: Count,
  placed: Count,
  percent: z.number().min(0).max(100).nullable(),
})
export const PublicClassesResponse = z.strictObject({ classes: z.array(ClassRef) })
export const PublicClassGuideResponse = z.strictObject({
  class: ClassRef,
  shows: Count,
  typicalField: z.number().nonnegative(),
  ribbonOdds: Odds,
  years: z.array(
    z.strictObject({
      year: z.number().int(),
      shows: Count,
      medianEntries: z.number().nonnegative().nullable(),
    })
  ),
  coEntries: z.strictObject({
    shows: Count,
    missingShows: Count,
    entrants: Count,
    classes: z.array(
      ClassRef.extend({
        entrants: Count,
        percent: z.number().min(0).max(100).nullable(),
      }).strict()
    ),
  }),
  latestShows: z.array(
    z.strictObject({
      series: PublicSeriesRef,
      show: PublicShow,
      entries: Count,
      ribbonOdds: Odds,
    })
  ),
})
export type PublicClassesOutput = z.infer<typeof PublicClassesResponse>
export type PublicClassGuideOutput = z.infer<typeof PublicClassGuideResponse>
